<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "app",
  components: {},
  data() {
    return {};
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
.hidden {
  display: none;
}
</style>
